export const genderDisplays = {
  man: "男性",
  woman: "女性",
} as const;
export type GenderDisplays =
  (typeof genderDisplays)[keyof typeof genderDisplays];

export const parliamentaryDisplays = {
  SYUGIIN: "衆議院",
  SANGIIN: "参議院",
} as const;
export type ParliamentaryDisplays =
  (typeof parliamentaryDisplays)[keyof typeof parliamentaryDisplays];

export const regionDisplays = {
  HOKKAIDO: "北海道",
  TOUHOKU: "東北",
  KITAKANTOU: "北関東",
  TOKYOTO: "東京",
  MINAMIKANTOU: "南関東",
  TOUKAI: "東海",
  HOKURIKUSHINETSU: "北陸信越",
  KINKI: "近畿",
  CHUGOKU: "中国",
  SHIKOKU: "四国",
  KYUSHU: "九州",
  ZENKOKU: "全国比例",
} as const;
export type RegionDisplays =
  (typeof regionDisplays)[keyof typeof regionDisplays];

export const prefecturesDisplays = {
  HOKKAIDO: "北海道",
  AOMORI: "青森",
  IWATE: "岩手",
  MIYAGI: "宮城",
  AKITA: "秋田",
  YAMAGATA: "山形",
  FUKUSHIMA: "福島",
  IBARAKI: "茨木",
  TOCHIGI: "栃木",
  GUNMA: "群馬",
  SAITAMA: "埼玉",
  CHIBA: "千葉",
  TOKYO: "東京",
  KANAGAWA: "神奈川",
  NIIGATA: "新潟",
  TOYAMA: "富山",
  ISHIKAWA: "石川",
  FUKUI: "福井",
  YAMANASHI: "山梨",
  NAGANO: "長野",
  GIFU: "岐阜",
  SHIZUOKA: "静岡",
  AICHI: "愛知",
  MIE: "三重",
  SHIGA: "滋賀",
  KYOTO: "京都",
  OSAKA: "大阪",
  HYOGO: "兵庫",
  NARA: "奈良",
  WAKAYAMA: "和歌山",
  TOTTORI: "鳥取",
  SHIMANE: "島根",
  OKAYAMA: "岡山",
  HIROSHIMA: "広島",
  YAMAGUCHI: "山口",
  TOKUSHIMA: "徳島",
  KAGAWA: "香川",
  EHIME: "愛媛",
  KOCHI: "高知",
  FUKUOKA: "福岡",
  SAGA: "佐賀",
  NAGASAKI: "長崎",
  KUMAMOTO: "熊本",
  OITA: "大分",
  MIYAZAKI: "宮崎",
  KAGOSHIMA: "鹿児島",
  OKINAWA: "沖縄",
  HIREI: "比例",
} as const;
export type PrefecturesDisplays =
  (typeof prefecturesDisplays)[keyof typeof prefecturesDisplays];

export const statisticTypes = {
  PEOPLE: "人",
  YEN: "円",
  KEN: "件",
  PERCENT: "％",
} as const;
export type StatisticTypes =
  (typeof statisticTypes)[keyof typeof statisticTypes];

export const statisticUnits = {
  ONE: "",
  TEN: "十",
  ONE_HUDRED: "百",
  ONE_THOUSAND: "千",
  TEN_THOUSAND: "万",
  ONE_HUNDRED_THOUSAND: "十万",
  ONE_MILLION: "百万",
  TEN_MILLION: "千万",
  ONE_HUNDRED_MILLION: "億",
  ONE_BILLION: "十億",
  TEN_BILLION: "百億",
  ONE_HUNDRED_BILLION: "千億",
  ONE_TRILLION: "兆",
} as const;
export type StatisticUnits =
  (typeof statisticUnits)[keyof typeof statisticUnits];
